<template>
  <div>
    <b-form-input type="password"
                  :state="passwordState"
                  :class="[mInput && 'm-input']"
                  v-model="mutableValue"
                  :placeholder="placeholder"
                  autocomplete="password"
                  @input="$emit('input', $event)"
                  aria-describedby="passwordFeedback">
    </b-form-input>
    <b-form-invalid-feedback id="passwordFeedback">
      {{ passwordFeedbackText }}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
  export default {
    name: "PasswordInput",
    props: {
      value: String,
      placeholder: String,
      mInput: Boolean,
    },
    data() {
      return {
        mutableValue: this.value
      }
    },
    computed: {
      passwordState() {
        if (this.mutableValue.length === 0) {
          return null;
        }

        return !(this.mutableValue.length < 8
          || !this.mutableValue.match(/[0-9]/)
          || !this.mutableValue.match(/[a-z]/)
          || !this.mutableValue.match(/[A-Z]/));
      },
      passwordFeedbackText() {
        if (this.mutableValue.length < 8) {
          return 'Hasło musi zawierać przynajmniej 8 znaków.'
        }

        if (!this.mutableValue.match(/[0-9]/)) {
          return 'Hasło musi zawierać przynajmniej jedną cyfrę.'
        }

        if (!this.mutableValue.match(/[a-z]/)) {
          return 'Hasło musi zawierać przynajmniej jedną małą literę.'
        }

        if (!this.mutableValue.match(/[A-Z]/)) {
          return 'Hasło musi zawierać przynajmniej jedną dużą literę.'
        }
      }
    },
    watch: {
      mutableValue() {
        if (this.passwordState === true) {
          this.$emit('valid')
        } else {
          this.$emit('invalid')
        }
      },
      value(v) {
        this.mutableValue = v;
      }
    }
  }
</script>

<style scoped>

</style>
